import React, { useState } from 'react';

function BookLayout({ 
  title, 
  coverImage, 
  coverAlt, 
  description, 
  sampleText, 
  chapterTitle, 
  timeStamp,
  excerptNotice 
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openDescriptionModal = () => setIsDescriptionModalOpen(true);
  const closeDescriptionModal = () => setIsDescriptionModalOpen(false);

  return (
    <>
      <div className="book-layout">
        <div className="book-cover">
          <img src={coverImage} alt={coverAlt} />
          <button className="sample-link" onClick={openModal}>
            Read a Sample
          </button>
        </div>
        
        <button className="description-toggle" onClick={openDescriptionModal}>
          View Description
        </button>
        
        <div className="book-details">
          {description.slice(0, 2).map((paragraph, index) => (
            <p key={index} className="book-description" style={index === 0 ? { fontWeight: 'bold' } : {}}>
              {paragraph}
            </p>
          ))}
          <button className="read-more-link" onClick={openDescriptionModal}>
            Read More
          </button>
        </div>
      </div>

      {/* Sample Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{title}</h2>
              <button className="modal-close" onClick={closeModal}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <p className="chapter-title">{chapterTitle}</p>
              <p className="time-stamp">{timeStamp}</p>
              {sampleText.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              <p className="excerpt-notice"><em>{excerptNotice}</em></p> 
            </div>
          </div>
        </div>
      )}

      {/* Description Modal */}
      {isDescriptionModalOpen && (
        <div className="modal-overlay" onClick={closeDescriptionModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>About The Door In Penrose Forest</h2>
              <button className="modal-close" onClick={closeDescriptionModal}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              {description.map((paragraph, index) => (
                <p key={index} style={index === 0 ? { fontWeight: 'bold' } : {}}>
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BookLayout; 